export const SIMO_VAR = "USER_SIMO"

export const SIMO_VAR_PRERENDER = "SIMO_PRERENDER"
export const SIMO_VAR_POSTRENDER = "SIMO_POSTRENDER"

export const GROUP_SERVICE_SERIES = "GROUP_SERVICE_SERIES"